export default function getImageUrl(originalUrl, width, height, quality, enableDpr) {
    if (width === void 0) { width = 100; }
    if (height === void 0) { height = 100; }
    if (quality === void 0) { quality = 80; }
    if (enableDpr === void 0) { enableDpr = true; }
    var devicePixelRatio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    width = enableDpr ? Math.round(devicePixelRatio * width) : Math.round(width);
    height = enableDpr ? Math.round(devicePixelRatio * height) : Math.round(height);
    return (originalUrl &&
        typeof originalUrl === 'string' &&
        originalUrl
            .replace('http://rukmini1', 'https://rukminim1')
            .replace('{@width}', width.toString())
            .replace('{@height}', height.toString())
            .replace('{@quality}', quality.toString())) || '';
}
/**
 * Parses a string or number representing an aspect ratio and returns its numeric value.
 *
 * The function attempts to interpret the input `aspectRatio` in the following ways:
 * - If it's a string in the format "width:height" (e.g., "16:9"), it calculates the aspect ratio as height / width.
 * - If it's a number, it returns the number directly, assuming it's already the aspect ratio.
 * - If `aspectRatio` is empty (null or undefined), not a valid string format, or not a number, it returns the provided `fallbackVal`.
 *
 * @param aspectRatio - A string or number representing the aspect ratio.
 * String format should be "width:height".
 * @param fallbackVal - The numeric value to return if `aspectRatio` is invalid or empty.
 * @returns The numeric aspect ratio (height / width) or the `fallbackVal` if parsing fails.
 *
 * @example
 * ```typescript
 * parseAspectRatio("16:9", 1); // Returns 0.5625
 * parseAspectRatio("4:3", 1);  // Returns 0.75
 * parseAspectRatio(1.777, 1); // Returns 1.777
 * parseAspectRatio("invalid", 1); // Returns 1
 * parseAspectRatio("", 1);      // Returns 1
 * parseAspectRatio(null, 1);    // Returns 1
 * ```
 */
export var parseAspectRatio = function (aspectRatio, fallbackVal) {
    if (aspectRatio === void 0) { aspectRatio = ""; }
    if (aspectRatio) {
        if (typeof aspectRatio === "string" &&
            aspectRatio.includes(":") &&
            aspectRatio.split(":").length === 2 &&
            !aspectRatio.split(":").find(function (i) { return isNaN(Number(i)); })) {
            var _a = aspectRatio.split(":").map(function (x) { return Number(x); }), width = _a[0], height = _a[1];
            return height / width;
        }
        else if (typeof aspectRatio === "number") {
            return aspectRatio;
        }
        return fallbackVal;
    }
};
